import {useMemo} from 'react'
import {useEntryPointLoader, useRelayEnvironment} from 'react-relay'

export function useEntryPointLoaderWithEnvironment<T>(entryPoint: T) {
  const environment = useRelayEnvironment()
  const environmentProvider = useMemo(() => ({getEnvironment: () => environment}), [environment])
  return useEntryPointLoader(environmentProvider, entryPoint)
}
